import { render, staticRenderFns } from "./lamsRegLegalAnnualReport.vue?vue&type=template&id=050e4842&scoped=true&"
import script from "./lamsRegLegalAnnualReport.vue?vue&type=script&lang=js&"
export * from "./lamsRegLegalAnnualReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e4842",
  null
  
)

export default component.exports